import styled from 'styled-components';
import Image from '../../common/Image/Image';

/*** image container */

export const ImageBannerContainer = styled(Image)(
  props => `
  width: 100%;
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  object-fit: contain; // cover
  margin-bottom:${props.theme.spacing.base};
`,
);

export const ImageBannerOnClickContainer = styled.div(
  props => `
  width: 100%;
  cursor: pointer;
  `,
);

export const SliderArrowRight = styled.div(
  props => `
    width: 4rem;
    height: 4rem;
    display: flex;
    border-radius: ${props.theme.misc.borderRadius.round};
    background-color: ${props.theme.colors.goWhite.base};
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: -2rem;
    transform: translateY(-50%);
    box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
    border:none;
    &:focus{
      outline: none;
    }
  `,
);

export const SliderArrowLeft = styled.div(
  props => `
    width: 4rem;
    height: 4rem;
    display: flex;
    border-radius: ${props.theme.misc.borderRadius.round};
    background-color: ${props.theme.colors.goWhite.base};
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    top: 50%;
    left: -2rem;
    transform: translateY(-50%);
    box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
    border:none;
    &:focus{
      outline: none;
    }
  `,
);
